import useLayeredContent from './useLayeredContent'
import type { FaqCollection, FaqSection } from '../../utils/faqs-config'

export function useContentFaq() {
    const { queryAll, queryBySlug } = useLayeredContent()

    async function getFaqCollections() {
        return await queryAll<FaqCollection>('faqs/collections')
    }

    async function getFaqCollectionBySlug(slug: string) {
        return await queryBySlug<FaqCollection>('faqs/collections', slug)
    }

    async function getFaqSections() {
        return await queryAll<FaqSection>('faqs/sections')
    }

    async function getFaqSectionBySlug(slug: string) {
        return await queryBySlug<FaqSection>('faqs/sections', slug)
    }

    return { getFaqCollections, getFaqCollectionBySlug, getFaqSections, getFaqSectionBySlug }
}
